export default __webpack_public_path__ + "static/media/icono-white-next.0e5d5cdf.svg";